// src/api/clientsApi.js
import apiClient from './client';

const clientsApi = {
  getClients: async (params = {}) => {
    try {
      console.log('API call with params:', params);
      // Now passing the params to the API call
      const response = await apiClient.get('/clients', { params });
      console.log("Clients response:", response.data);
      return response.data;
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Request was aborted');
      } else {
        console.error('Error fetching clients:', error);
      }
      // Return properly structured fallback
      return { clients: [], total: 0 };
    }
  },
  
  getClient: async (id) => {
    try {
      const response = await apiClient.get(`/clients/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching client ${id}:`, error);
      throw error;
    }
  },
  
  // Client related data methods
  getClientAlerts: async (id, params = {}) => {
    try {
      const response = await apiClient.get(`/clients/${id}/alerts`, { params });
      return response.data;
    } catch (error) {
      console.error(`Error fetching client alerts for ${id}:`, error);
      throw error;
    }
  },

  getClientAllergies: async (id, params = {}) => {
    try {
      const response = await apiClient.get(`/clients/${id}/allergies`, { params });
      return response.data;
    } catch (error) {
      console.error(`Error fetching client allergies for ${id}:`, error);
      throw error;
    }
  },

  getClientCommunications: async (id, params = {}) => {
    try {
      const response = await apiClient.get(`/clients/${id}/communications`, { params });
      return response.data;
    } catch (error) {
      console.error(`Error fetching client communications for ${id}:`, error);
      throw error;
    }
  },

  getClientDocuments: async (id, params = {}) => {
    try {
      const response = await apiClient.get(`/clients/${id}/documents`, { params });
      return response.data;
    } catch (error) {
      console.error(`Error fetching client documents for ${id}:`, error);
      throw error;
    }
  },

  getClientNotes: async (id, params = {}) => {
    try {
      const response = await apiClient.get(`/clients/${id}/notes`, { params });
      return response.data;
    } catch (error) {
      console.error(`Error fetching client notes for ${id}:`, error);
      throw error;
    }
  },

  getClientMarketingPreferences: async (id) => {
    try {
      const response = await apiClient.get(`/clients/${id}/marketing-preferences`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching client marketing preferences for ${id}:`, error);
      throw error;
    }
  },

  getClientPayments: async (id, params = {}) => {
    try {
      const response = await apiClient.get(`/clients/${id}/payments`, { params });
      return response.data;
    } catch (error) {
      console.error(`Error fetching client payments for ${id}:`, error);
      throw error;
    }
  },

  getClientInvoices: async (id, params = {}) => {
    try {
      const response = await apiClient.get(`/clients/${id}/invoices`, { params });
      return response.data;
    } catch (error) {
      console.error(`Error fetching client invoices for ${id}:`, error);
      throw error;
    }
  },

  getClientForms: async (id, params = {}) => {
    try {
      const response = await apiClient.get(`/clients/${id}/forms`, { params });
      return response.data;
    } catch (error) {
      console.error(`Error fetching client forms for ${id}:`, error);
      throw error;
    }
  },

  getFormSubmission: async (formId) => {
    try {
      const response = await apiClient.get(`/forms/submissions/${formId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching form submission ${formId}:`, error);
      throw error;
    }
  },

  // NEW: Single endpoint to get all counts for better performance
  getClientCounts: async (id) => {
    try {
      const response = await apiClient.get(`/clients/${id}/counts`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching client counts for ${id}:`, error);
      throw error;
    }
  },
  
  async getDocumentBlob(documentId) {
    try {
      const response = await apiClient.get(`/documents/${documentId}/view`, {
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching document blob for ${documentId}:`, error);
      if (error.response) {
        console.error('Error data:', error.response.data);
        console.error('Error status:', error.response.status);
        console.error('Error headers:', error.response.headers);
      } else if (error.request) {
        console.error('Error request:', error.request);
      } else {
        console.error('Error message:', error.message);
      }
      throw error;
    }
  },
  
  async getDocumentViewUrl(documentId) {
    try {
      const response = await apiClient.get(`/documents/${documentId}/view`);
      return response.data; // Should be { url: "...", source: "..." }
    } catch (error) {
      console.error(`Error fetching document view URL for ${documentId}:`, error);
      throw error;
    }
  },
  
  // Add other client-related methods as needed
  createClient: async (clientData) => {
    try {
      const response = await apiClient.post('/clients', clientData);
      return response.data;
    } catch (error) {
      console.error('Error creating client:', error);
      throw error;
    }
  },
  
  updateClient: async (id, clientData) => {
    try {
      const response = await apiClient.put(`/clients/${id}`, clientData);
      return response.data;
    } catch (error) {
      console.error(`Error updating client ${id}:`, error);
      throw error;
    }
  },
  
  deleteClient: async (id) => {
    try {
      const response = await apiClient.delete(`/clients/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting client ${id}:`, error);
      throw error;
    }
  }
};

export default clientsApi;